var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',{staticClass:"mx-auto d-flex flex-column",attrs:{"lg":"12"}},[_c('b-card',{staticStyle:{"background":"transparent","border":"1px solid rgba(255, 255, 255, 0.1)"}},[_c('b-card-title',[_vm._v("Pre Start Downloads")]),_c('server-pre-start-download-tasks')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }